export interface SimplePerson {
  fullName: string;
  avatar?: string | null;
  href?: string | null;
}

export const THEAD_CLASSES = "tw-border-[1px] tw-border-solid tw-border-x-0 tw-border-gray-5";
